/* eslint-disable react/button-has-type */
/* eslint-disable react/prop-types */
import React, { useContext, useState } from 'react';
import Link from 'next/link';
import { HeaderContext } from '../../../contexts/headerContext';

function ViewAllButton({
  pageUrl, queryString = '', typeButton = 1, textButton = 'View All', hiddenLgBTn = true, pageType, pageTitle,
}) {
  const [type] = useState(pageType);
  const { setHeaderData } = useContext(HeaderContext);

  const handleNavigate = () => {
    setHeaderData({
      headerTitle: pageTitle,
      headerBreadCrumb: pageTitle,
    });
    sessionStorage.setItem('headerData', pageTitle);
  };

  if (typeButton !== 1) {
    return (
      <div className="flex justify-center items-center">
        <Link
          href={{
            pathname: pageUrl,
            ...(queryString ? { search: queryString } : {}),
          }}
          onClick={handleNavigate}
          state={{ type }}
          className={`text-lightSky flex justify-center items-center text-sm ${hiddenLgBTn ? 'hidden' : 'flex'} lg:flex`}
        >
          {textButton}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-4 w-4"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M9 5l7 7-7 7"
            />
          </svg>
        </Link>

      </div>

    );
  }
  return (
    <div className="pr-5">
      <Link href={{
        pathname: pageUrl,
        ...(queryString ? { search: queryString } : {}),
      }}
      >
        <button
          className="flex items-center w-full justify-center border border-blue-300 text-customBlue px-4 py-2 rounded-md hover:bg-blue-50 transition"
          aria-label="View All "
        >
          <span className="mr-2">{textButton}</span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-4 w-4"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M9 5l7 7-7 7"
            />
          </svg>
        </button>
      </Link>
    </div>
  );
}

export default ViewAllButton;
